import React from 'react';
import { Modal } from 'antd';
import { useTranslation } from 'react-i18next';

import { MinimalClientCompany } from '../../bookingOrders/types/ClientCompany';
import ContactPerson from '../../bookingOrders/types/ContactPerson';
import { DisplayedCourseInstance } from '../../courseInstance/types/CourseInstance';
import BookingOrderInformation from '../../bookingOrders/components/BookingOrderInformation';

import Search from './Search';
import SubsidiaryCompany from '../../subsidiaryCompany/types/SubsidiaryCompany';

type SearchModalProps = {
  visible: boolean;
  clientCompany?: MinimalClientCompany;
  subsidiaryCompany: SubsidiaryCompany;
  contactPerson?: ContactPerson;
  onCancel: () => void;
  createDisplayedCourseInstance?: (
    displayedCourseInstance: DisplayedCourseInstance,
  ) => Promise<boolean | void> | boolean | void;
};

const SearchModal: React.FC<SearchModalProps> = ({
  visible,
  clientCompany,
  subsidiaryCompany,
  contactPerson,
  onCancel,
  createDisplayedCourseInstance,
}) => {
  const { t } = useTranslation();
  return (
    <Modal
      open={visible}
      className="w-10/12 flex flex-col"
      onCancel={onCancel}
      footer={null}>
      <div className="text-lg font-semibold pb-3">
        {t('components.SearchModal.createCourseInstance')}
      </div>
      {(clientCompany || contactPerson) && (
        <div className="-mx-6">
          <BookingOrderInformation
            clientCompany={clientCompany}
            contactPerson={contactPerson}
          />
        </div>
      )}
      <Search
        contactPerson={contactPerson}
        clientCompany={clientCompany}
        subsidiaryCompany={subsidiaryCompany}
        onSubmit={createDisplayedCourseInstance}
      />
    </Modal>
  );
};

export default SearchModal;
